import { AwardingClient } from "@/utils/EvoClient";
import { JoinOrganisationDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "users/c/join-organisation";

export default async function joinOrganisation(
  dto: JoinOrganisationDto
): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
